"use client";

import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/navigation";
import { signOut } from "next-auth/react";

export default function Appbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const router = useRouter();
  const dropdownRef = useRef(null); // Reference for dropdown
  const buttonRef = useRef(null); // Reference for the dropdown button

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setDropdownOpen(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 px-6 py-4 lg:px-16 transition-all duration-300 ${
        isScrolled
          ? "bg-gradient-to-b from-zinc-950 to-transparent"
          : "bg-black"
      } shadow-lg rounded-b-2xl`}
    >
      {/* Logo and Navigation */}
      <div className="flex items-center justify-between">
        <button
          onClick={() => router.push("/")}
          className="text-3xl font-bold text-white tracking-wide hover:scale-105 transition-transform duration-300"
        >
          Profit
          <span className="bg-gradient-to-r from-indigo-700 via-indigo-600 to-indigo-500 inline-block text-transparent bg-clip-text">
            ONN
          </span>
        </button>

        {/* Sign Up and Sign In Buttons */}
        <div className="hidden lg:flex gap-4">
          <button
            onClick={() => router.push("/about")}
            className="border-2 rounded-lg border-white box-border px-6 py-2 text-lg font-medium transform transition-transform hover:scale-105 duration-300 hover:bg-zinc-950"
          >
            About us
          </button>
          <button
            onClick={() => router.push("/signin")}
            className="rounded-lg box-border px-6 py-2 text-lg font-medium bg-indigo-700 text-white hover:bg-indigo-600 transform transition-transform hover:scale-105 duration-300"
          >
            Sign In
          </button>
        </div>

        {/* Hamburger Menu for smaller screens */}
        <button
          onClick={toggleDropdown}
          ref={buttonRef}
          className="lg:hidden text-white focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-8 h-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </button>
      </div>

      {/* Dropdown Menu for smaller screens */}
      {dropdownOpen && (
  <div
    id="dropdown"
    ref={dropdownRef}
    className="absolute right-2 mt-2 z-10 bg-slate-950 divide-y divide-gray-700 rounded-lg shadow-lg w-32 transition-all duration-300 transform opacity-100 scale-100 border border-gray-600"
  >
    <ul className="py-2 rounded-lg text-sm text-white shadow-2xl">
      <li>
        <button
          onClick={() => router.push("/")}
          className="block px-4 py-2 text-start w-full lg:hover:bg-indigo-600 rounded-md  lg:hover:scale-105 transition-all duration-300"
        >
          Home
        </button>
      </li>
      <li>
        <button
          onClick={() => router.push("/about")}
          className="block px-4 py-2 text-start w-full lg:hover:bg-indigo-600 rounded-md  lg:hover:scale-105 transition-all duration-300"
        >
          About
        </button>
      </li>
      <li>
        <button
          onClick={() => router.push("/signin")}
          className="block px-4 py-2 text-start w-full lg:hover:bg-indigo-600 rounded-md  lg:hover:scale-105 transition-all duration-300"
        >
          Sign In
        </button>
      </li>
    </ul>
  </div>
)}

    </header>
  );
}
